export const CONFIRM_AND_BOOK_CTA_TEXT = "Confirm and book";

export const AGE_BAND_MISMATCH_NOTICE =
  "The ages of the travelers you've selected don't match the ticket types chosen in the previous step";
